/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import type {ErrorInfo, ReactNode} from 'react';
import {Component} from 'react';

interface Props {
	children?: ReactNode;
	fallBack?: ReactNode;
}

interface State {
	hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {hasError: false};
	}

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		return {hasError: true};
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Uncaught error:', error, errorInfo);
		return {hasError: true};
	}

	public render() {
		if (this.state.hasError) {
			return this.props.fallBack;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
